export default "__VITE_ASSET__DXdrTjxX__"